import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable ,  EMPTY as empty } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';
import { API_ROUTES } from 'app/shared/utils/utils';
import { Favorite } from '../models/favorite.model';

@Injectable()
export class FavoriteService extends BaseAuthService {
  readonly ADD_ACTION = 'add';
  readonly REMOVE_ACTION = 'remove';

  constructor(protected http: HttpClient, protected authService: AuthService) {
    super(http, authService);
  }

  get addToFavorites() {
    return this.changeFavorite(this.ADD_ACTION);
  }

  get removeFromFavorites() {
    return this.changeFavorite(this.REMOVE_ACTION);
  }

  getFavorites({ start = 0, limit = 10 }): Observable<Favorite[]> {
    if (this.authService.authenticated === false) {
      return null;
    }

    return this.get('favoriteList', { start, limit, auth_tokens: true }).pipe(
      map(results => results.map(result => Favorite.fromObject(result)))
    );
  }

  updateFavorite(type: string, id: number, add = false) {
    if (add) {
      return this.addToFavorites(type, id);
    }
    return this.removeFromFavorites(type, id);
  }

  private changeFavorite(action: string) {
    return (type: string, id: number) => {
      if (this.authService.authenticated === false) {
        return null;
      }

      return this.post(API_ROUTES.favorite, { type, type_id: id, action, auth_tokens: true });
    };
  }
}
